window.APP_CONFIG = {
    MLC_ENV: process.env.MLC_ENV ?? '',
    API_HOST: process.env.API_HOST ?? '',
    API_2V_HOST: process.env.API_2V_HOST ?? '',
    API_PROTO: process.env.API_PROTO ?? '',
    API_2V_PROTO: process.env.API_2V_PROTO ?? '',
    ALLOWED_DOWNLOAD_ORIGINS: process.env.ALLOWED_DOWNLOAD_ORIGINS ?? '',
    SEGMENT_KEY: process.env.SEGMENT_KEY ?? '',
    USER_PILOT_TOKEN: process.env.USER_PILOT_TOKEN ?? '',
    GTM_AUTH: process.env.GTM_AUTH ?? '',
    GTM_PREVIEW: process.env.GTM_PREVIEW ?? '',
    DATADOG_APPLICATION_ID: process.env.DATADOG_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
    COOKIE_BOT_CBID: process.env.COOKIE_BOT_CBID ?? '',
    INSIGHT_APP_SEC_APP_ID: process.env.INSIGHT_APP_SEC_APP_ID ?? '',
    LAUNCH_DARKLY_CLIENT_ID: process.env.LAUNCH_DARKLY_CLIENT_ID ?? '',
    HUBSPOT_PORTAL_ID: process.env.HUBSPOT_PORTAL_ID ?? '',
    HUBSPOT_CONTACT_US_FORM_ID: process.env.HUBSPOT_CONTACT_US_FORM_ID ?? '',
    AU10TIX_WORKFLOW_ROOT_URI: process.env.AU10TIX_WORKFLOW_ROOT_URI ?? '',
} as const

// eslint-disable-next-line no-console
console.log('Parsing Config!')
